export default {"src":"/nachrichten/_next/static/media/ThemeDarkIcon.b87579d6.svg","height":124,"width":70,"blurWidth":0,"blurHeight":0};